module.exports = __webpack_public_path__ + "img/stripe-logo.a27ca4a6.svg";